import { render, staticRenderFns } from "./add-paper-from-dio.html?vue&type=template&id=b1228d00&scoped=true&external"
import script from "./add-paper-from-dio.js?vue&type=script&lang=js&external"
export * from "./add-paper-from-dio.js?vue&type=script&lang=js&external"
import style0 from "./add-paper-from-dio.scss?vue&type=style&index=0&id=b1228d00&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1228d00",
  null
  
)

export default component.exports